import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  margin-top: 30px;
  padding: 30px;
`;

export const SmartphoneContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`;
